module.exports = __webpack_public_path__ + "img/completed-documents.59ed1700.svg";